module.exports = __webpack_public_path__ + "static/img/product-part1.49824a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product-part1.png
// module id = 5kk6
// module chunks = 1